module.exports = __webpack_public_path__ + "img/cancun-bay-resort-3.7777c4c4.jpg";